"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactQuery = require("react-query");
var _SettingsClient = require("@cimpress-technology/react-platform-settings/lib/SettingsClient");
var _settings = _interopRequireDefault(require("../constants/settings"));
var useGlobalSettings = function useGlobalSettings() {
  return (0, _reactQuery.useQuery)([_settings["default"].GLOBAL_SETTINGS_QUERY_KEY], _SettingsClient.getSettings);
};
var _default = exports["default"] = useGlobalSettings;